// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StEjU{position:absolute}.VZNbK{margin:7rem auto 5rem}.MsBDG{margin:24px 0;line-height:32px}.lprA8{font-family:TCCC-UnityText,sans-serif}`, "",{"version":3,"sources":["webpack://./src/components/communityTagsCarousel/CommunityTagsCarousel.module.scss"],"names":[],"mappings":"AAAA,OACE,iBAAA,CAGF,OACE,qBAAA,CAGF,OACE,aAAA,CACA,gBAAA,CAGF,OACE,qCAAA","sourcesContent":[".imageBg {\n  position: absolute;\n}\n\n.communityTagsCarousel {\n  margin: 7rem auto 5rem;\n}\n\n.title {\n  margin: 24px 0;\n  line-height: 32px;\n}\n\n.description {\n  font-family: TCCC-UnityText, sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"imageBg": `StEjU`,
	"communityTagsCarousel": `VZNbK`,
	"title": `MsBDG`,
	"description": `lprA8`
};
export default ___CSS_LOADER_EXPORT___;
